<template>
  <div class="wrap">
    <myHead nav="0"></myHead>
    <div class="main-content flex-sb">
        <conMenu menuTitle="业务栏目" :current="type.id" :menuList="typeList" @handleMenuClick="handleMenuClick"></conMenu>
        <div class="content main">
          <div class="main-head">
            <i class="el-icon-menu"></i>
            {{type.name}}
          </div>
          <div class="section-one" v-if="s_type == 1">
              <div class="section-item" :style="[{'background':'url('+service.cover+')'}]" v-for="(service,index) in service_list" :key="index" @mouseover="onMouseOver(index)" @mouseout="onMouseLeave()">
                <div class="section-con">
                  <img class="con-icon" :src="service.icon" height="65" width="65">
                  <div class="con-title">代理国内招标业务</div>
                  <div class="short-horizontal-line"></div>
                </div>
                <div class="detail" :class="over_index==index?'show':'hide'" :style="[{'height':232 * row_num - 18 +'px'}]">
                  <div class="detail-title">{{service.name}}</div>
                  <div class="detail-short-line"></div>
                  <div class="detail-info">{{service.content}}</div>
                </div>
              </div>
          </div>
          <div class="section-two" v-if="s_type > 1">
            <conDetail :detail="detail" :prev="prev" :next="next" @showDetail="showDetail"></conDetail>
          </div>
        </div>
    </div>
    <myFoot></myFoot>
  </div>
</template>
<!-- 业务栏目 -->
<script>
  import Vue from 'vue';
  import myHead from '../../components/myHead/myhead';
  import myFoot from '../../components/myFoot/myfoot';
  import conMenu from '../../components/conMenu/conmenu';
  import common from '../../assets/js/utils/common';
  import conDetail from '../../components/conDetail/condetail';
  import {
    mapActions,
    mapState,
    mapMutations
  } from "vuex";
  
  export default {
    name: "channel",
    components: {
      myHead,
      myFoot,
      conMenu,
      conDetail
    },
    data() {
      return {
        typeList: [
          {id:1,name:'服务栏目'},
          {id:2,name:'业务范围'},
          {id:3,name:'业务流程'},
        ],
        type:{},
        s_type: 1,
        is_loading: false,
        service_list:[],
        detail:{},
        row_num:2,
        over_index: -1,
        next:{},
        prev:{},
      }
    },
    mounted() {
      let s_type = this.$route.query.s_type
      if(s_type){
        this.s_type = parseInt(s_type)
      }
      this.type = this.typeList.find(val => val.id == this.s_type)
      this.getDetail()
    },
    computed: {
    },
    created() {
    },
    watch: {
      s_type(val){
        console.log(val)
        if(val){
          this.getDetail()
        }
      },
    },
    methods: {
      ...mapActions({
        getServiceIndex: "index/getServiceIndex",
        getProjectBusinessDetail: "index/getProjectBusinessDetail",
        getProjectProcessDetail: "index/getProjectProcessDetail",
      }),
      onMouseOver(index){
        this.over_index = index
      },
      onMouseLeave(){
        this.over_index = -1
      },
      getDetail(){
        let s_type = this.s_type
        if(s_type == 1){
          this.getService()
        }else if(s_type == 2){
          this.getProjectBusiness()
        }else{
          this.getProjectProcess()
        }
      },
      //服务栏目
      getService(){
        this.getServiceIndex({data:{},success:(res) => {
          if(res.code == 1){
            this.service_list = res.data.list
            if(this.service_list.length>0){
              let row_num = Math.ceil(this.service_list.length / 2)
              this.row_num = row_num>this.row_num?row_num:this.row_num
            }
          }
        }})
      },
      //业务范围
      getProjectBusiness(){
        this.getProjectBusinessDetail({data:{},success:(res) => {
          if(res.code == 1){
            this.detail = res.data.detail
          }
        }})
      },
      //业务流程
      getProjectProcess(){
        this.getProjectProcessDetail({data:{},success:(res) => {
          if(res.code == 1){
            this.detail = res.data.detail
            this.prev = {}
            this.next = {}
          }
        }})
      },
      
      handleMenuClick(row){
       this.type = row
       this.s_type = row.id
      },
      
      showDetail(id){
        this.$router.push({name:'channel',query:{s_type:this.s_type,id:id}})
        var param = {id:id}
        if(this.is_loading) return
        this.is_loading = true
        this.show_detail = true
        this.getProjectTenderDetail({data:param,success:(res) => {
          this.is_loading = false
          if(res.code == 1){
            this.detail = res.data.detail
            this.prev = {}
            this.next = {}
          }
        }})
      },
      
    }
  }
</script>

<style scoped>
  .main-content {
    position: relative;
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    margin: 30px auto 0;
    width: 1200px;
  }
  
  .main-content .main {
    width: 922px;
    background: #fff;
  }

  .main-head {
      text-align: left;
      position: relative;
      padding: 0 20px;
      font-size: 20px;
      font-weight: 700;
      background: #f5fafc;
      color: #0080FF;
      height: 72px;
      line-height: 72px;
    }
  
    .main-head::before {
     /* content: '';
      position: relative;
      top: 3px;
      display: inline-block;
      width: 20px;
      height: 20px; */
      /* background: #4370ff; */
      /* background: url(../../assets/images/title-before.png); */
    }

  .main-content .main .section-one {
    position: relative;
    padding: 16px 20px 0;
    border-bottom: 16px solid #fff;
    overflow: hidden;
    min-height: 455px;
    background-color: #fff;
  }
  .section-item{
    width: 420px;
    height: 214px;
    display: inline-block;
    margin: 0 10px 18px;
  }
  .section-item .section-con{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .section-item .detail.show{
    opacity: 1;
    transition: all 0.2s;
    pointer-events: none;
  }
  .section-item .detail.hide{
    opacity: 0;
    transition: all 0.2s;
    pointer-events: none;
  }
  .section-item:nth-child(2n - 1) .detail{
    left: 30px;
    top: 16px;
  }
  .section-item:nth-child(2n) .detail{
    right: 30px;
    top: 16px;
  }
  .con-icon{
    text-align: center;
    padding: 45px 0 15px 0;
  }
  .con-title{
    color: #FFF;
    font-size: 18px;
    line-height: 25px;
    text-align: center;
  }
  .short-horizontal-line{
    width: 45px;
    border-bottom: 4px solid #FFF;
    margin: 14px auto;
  }
  .section-item .detail{
    position: absolute;
    width: 420px;
    z-index: 1;
    background-color: #fff;
    border: 1px solid #ddd;
  }
  .section-item .detail .detail-title{
    text-align: center;
    font-weight: bold;
    font-size: 16px;
    margin-top: 35px;
  }
  .section-item .detail .detail-short-line{
    width: 45px;
    border-bottom: 4px solid #0080FF;
    margin: 14px auto;
  }
  .section-item .detail .detail-info{
    padding: 0 35px;
    line-height: 2;
  }
</style>
